var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-widget"},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.onCopy.apply(null, arguments)}}},[_c('icon',{attrs:{"name":"copy"}}),_vm._v("Copy embed URL ")],1),(_vm.copied)?_c('p',[_vm._v(" Copied embed URL to clipboard! ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }